<!--
 * @Author: xuchen
 * @Date: 2020-03-17 16:12:16
 * @Desc: 插件下载
 -->
<template>
  <h-page-container>
    <h-page-content>
      <template v-for="item in downloadList">
        <ul v-if="item.itemType === 'plugin'" :key="item.fileName">
          <h4>插件</h4>
          <li class="download">
            <a class="download-container" :href="`${downloadUrl}?fileName=${item.fileName}`">
              <div class="plugin-img">
                <img :src="logoPluginImg" />
              </div>
              <div class="plugin-content">
                <p class="title">{{ item.itemName }}</p>
                <p class="size">{{ item.itemSize }}M</p>
                <p v-ellipsis class="description">{{ item.description }}</p>
              </div>
            </a>
          </li>
        </ul>
        <ul v-if="item.itemType === 'app'" :key="item.fileName">
          <h4>APP</h4>
          <li>
            <div class="download-container">
              <div class="plugin-img">
                <img :src="logoAppImg" class="img-logo-app" />
              </div>
              <div class="plugin-content">
                <p class="title">{{ item.itemName }}</p>
                <p class="size">{{ item.itemSize }}M</p>
                <p v-ellipsis class="description">{{ item.description }}</p>
              </div>
            </div>
            <div class="download-orcode">
              <dl v-for="(qrcode, index) in item.qrcodes" :key="`qrcode_${index}`">
                <dt>{{ qrcode.name }}</dt>
                <dd>
                  <img :src="qrcode.url" class="img-orcode" />
                </dd>
              </dl>
            </div>
          </li>
        </ul>
      </template>
    </h-page-content>
  </h-page-container>
</template>

<script>
import http from '@/api/common.api'
import logoPluginImg from '@/assets/images/PluginDownload/logo-plugin.png'
import logoAppImg from '@/assets/images/PluginDownload/logo-app.png'

export default {
  name: 'PluginDownload',
  data() {
    return {
      logoPluginImg,
      logoAppImg,
      downloadUrl: http.pluginDownloadUrlPrefix, // 下载地址
      downloadList: [] // 下载列表
    }
  },
  created() {
    this.getDownloadList()
  },
  methods: {
    /**
     * @author xuchen
     * @date 2020-03-17 16:18:16
     * @desc 获取下载列表
     */
    async getDownloadList() {
      const { data } = await http.getPluginDownLoadUrls()
      data.forEach(item => {
        if (item.itemType === 'app') {
          item.qrcodes = this.parseQrcodeData(item.fileName)
        }
      })
      this.downloadList = data
    },

    /**
     * @author chenguanbin
     * @date 2020-04-22 20:19:25
     * @desc 解析二维码数据
     */
    parseQrcodeData(data) {
      try {
        const result = []
        data = JSON.parse(data)
        Object.keys(data).forEach(key => {
          const url = data[key]
          result.push({
            name: key,
            url
          })
        })
        return result
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  width: 480px;
  margin: 40px auto;
}
h4 {
  margin-bottom: 24px;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.9);
}
li {
  padding: 12px;
  background-color: #ffffff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  transition: all 0.2s;
  &.download:hover {
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
    opacity: 0.8;
  }
}
.download-container {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #999;
  font-size: 13px;
}
.plugin-img {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  img {
    border-radius: 8px;
  }
  .img-logo-app {
    width: 80px;
    height: 80px;
  }
}
.plugin-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  min-height: 80px;
  margin-left: 16px;
  .title {
    line-height: 20px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.9);
  }
  .size {
    line-height: 32px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
  }
  .description {
    line-height: 32px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
  }
}
.download-orcode {
  display: flex;
  justify-content: center;
  margin-top: 32px;
  dl {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
  }
  dt {
    color: #b5b5b5;
  }
  .img-orcode {
    width: 160px;
    height: 160px;
  }
}
</style>
